import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { STUDIO } from "@/data/content";

export const Contact = () => {
  const { t } = useLang();

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-[#0A0A0E] py-24 md:py-32 lg:py-40 border-t border-white/5"
    >
      <div className="mx-auto grid max-w-[1400px] gap-12 px-6 md:px-12 lg:grid-cols-[0.72fr_1.28fr] lg:items-end lg:gap-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p data-testid="contact-overline" className="font-mono text-xs tracking-[0.2em] uppercase font-bold text-zinc-500">
            {t.contact.overline}
          </p>
          <h2 data-testid="contact-heading" className="mt-5 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white">
            {t.contact.title}
          </h2>
        </motion.div>

        <motion.div
          data-testid="contact-details"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
          className="border-l border-[#00F0FF] pl-6 md:pl-8 lg:pb-1"
        >
          <p data-testid="contact-subtitle" className="max-w-3xl text-lg leading-relaxed text-zinc-300 md:text-xl">
            {t.contact.subtitle}
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
            <p data-testid="contact-direct-label" className="font-mono text-[11px] uppercase tracking-[0.16em] text-zinc-500">
              {t.contact.direct}
            </p>
            <a
              href={`mailto:${STUDIO.email}`}
              data-testid="contact-email-link"
              className="inline-flex w-fit items-center gap-3 font-heading text-xl text-white transition-colors duration-300 hover:text-[#00F0FF]"
            >
              <Mail className="h-5 w-5 text-[#00F0FF]" aria-hidden="true" />
              {STUDIO.email}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
